import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useTheme } from "./ThemeContext";

const SendModal = ({
  show,
  onClose,
  staffDepartment,
  selectedRoles,
  onCheck,
  onCheckAll,
  onSend,
  loading,
}) => {
  const { isDark } = useTheme();

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header
        closeButton
        className={isDark ? "bg-dark text-light border-secondary" : ""}
      >
        <Modal.Title>Send PA Form</Modal.Title>
      </Modal.Header>

      <Modal.Body className={isDark ? "bg-dark text-light" : ""}>
        {staffDepartment.length === 0 ? (
          <div className={isDark ? "text-secondary text-center" : "text-muted text-center"}>
            No appraisal form available for this staff.
          </div>
        ) : (
          staffDepartment.map((staffDept) => (
            <div
              key={`${staffDept.staff_id}_${staffDept.role_id}`}
              className={`p-3 rounded d-flex justify-content-between align-items-center mb-2 ${
                isDark
                  ? "bg-secondary bg-opacity-25 border border-secondary text-light"
                  : "bg-white border"
              }`}
            >
              <div className="fw-bold">{staffDept.display_name} ({staffDept.type})</div>
              <Form.Check
                type="checkbox"
                checked={!!selectedRoles[`${staffDept.staff_id}_${staffDept.role_id}`]}
                onChange={() => onCheck(`${staffDept.staff_id}_${staffDept.role_id}`)}
              />
            </div>
          ))
        )}
      </Modal.Body>

      <Modal.Footer className={isDark ? "bg-dark border-secondary" : ""}>
        <Button
          variant="secondary"
          onClick={onCheckAll}
          disabled={staffDepartment.length === 0}
        >
          Check All
        </Button>
        <Button
          variant="outline-light"
          style={{ background: "#B31E8D", color: "white" }}
          onClick={onSend}
          disabled={staffDepartment.length === 0}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" /> &nbsp;Sending...
            </>
          ) : (
            "Send"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendModal;
